
























































import { Component, Vue, Prop } from "vue-property-decorator";
import PurchaseManagementApi from "../../../api/accounting/purchase-management-api";
import VIconEdit from "../../../components/icons/VIconEdit.vue";
import VIconPrint from "../../../components/icons/VIconPrint.vue";
import { client } from "../../../api/request";
import VToolbar from "../../common/components/VToolbar.vue";
import VSearchBar from "../../../components/VSearchBar.vue";
import PrintApi from "../../../api/accounting/print-api";
import PurchaseService from "../../../usecases/accounting/purchase-management-service";
import PurchaseStatus from "../components/PurchaseStatus.vue";
import PurchaseSearchBar from "@/ui/common/components/InvoiceSearchBar.vue";
import PurchaseSearchOptions from "@/ui/common/presenters/invoice-search-options";
import SelectOption from "@/common/ui/presenters/select-option";
import { getAllProjects } from "../../../api/project-api";
import { getAllCompanies } from "@/api/company-api";
import PurchaseManagement from "@/usecases/accounting/purchase-management";

const purchaseApi = new PurchaseManagementApi(client);
const purchaseService = new PurchaseService(purchaseApi);
const printApi = new PrintApi(client);

@Component({
  components: {
    PurchaseStatus,
    VToolbar,
    VSearchBar,
    VIconEdit,
    VIconPrint,
    PurchaseSearchBar
  }
})
export default class PurchaseListPage extends Vue {
  @Prop() projectId?: string;
  @Prop({ type: Boolean }) editon!: boolean;
  items: PurchaseManagement[] = [];
  printStatus: boolean[] = [];
  isAllSelected: boolean = false;
  selectedIds: number[] = [];
  projects: SelectOption[] = [];
  companies: SelectOption[] = [];
  startDate = "";
  endDate = "";

  edit(id: number) {
    this.$router.push({
      name: "purchase-edit",
      params: {
        id: String(id)
      }
    });
  }
  statusOptions = [
    {
      text: "全て(ステータス)",
      value: ""
    },
    {
      text: "未発注",
      value: "created"
    },
    {
      text: "発注済み",
      value: "ordered"
    },
    {
      text: "送金済み",
      value: "paid"
    }
  ];

  searchOptions: PurchaseSearchOptions = {};

  search() {
    this.initProjectList();
    this.initCompanyList();
    this.initPurchaseList(this.searchOptions);
  }

  async changeStatus(id: string, status: string) {
    await purchaseService.changeStatus(id, status);
    await this.initPurchaseList();
  }

  protected created() {
    this.initProjectList();
    this.initCompanyList();
    this.initPurchaseList();
  }

  get projectOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.projects.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initProjectList() {
    this.projects = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  get companyOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.companies.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initCompanyList() {
    this.companies = (await getAllCompanies()).map(p => ({
      text: p.name,
      value: String(p.companyId)
    }));
  }

  async createPdf(id: number, index: number, printsExcludeTax: boolean) {
    if (!this.printStatus.includes(true)) {
      this.$set(this.printStatus, index, true);
      const url = await printApi.getPurchasePrint(
        id,
        this.$store.state.accessToken,
        printsExcludeTax
      );
      this.$set(this.printStatus, index, false);
      window.open(url, "発注書印刷");
    } else {
      alert(
        "現在他の発注書で印刷を生成中です。時間をおいてからもう一度試してください。"
      );
    }
  }

  private async initPurchaseList(options: PurchaseSearchOptions = {}) {
    const new_options = {
      ...options,
      projectId: this.searchOptions.project,
      companyId: this.searchOptions.company,
      status: this.searchOptions.status,
      startDate: this.searchOptions.startDate,
      endDate: this.searchOptions.endDate
    };
    this.items = await purchaseApi.findAll(new_options);
    for (var i = 0; i < this.items.length; i++) {
      this.printStatus.push(false);
    }
  }
}
